/*总书记讲历史*/
import {urlpostfix,jsonpostfix} from '@/config/global.js'
import {post} from '@/config/config.js'

/**/
export function getdetais(data){
  return post(`${urlpostfix}api/basic/info/${data}`);
}







// WEBPACK FOOTER //
// ./src/api/detais.js